import PropTypes from "prop-types";
import { cn } from "@helpers/general";
import ALShopifyImage from "@components/al_components/ALShopifyImage";
import { ALSkeleton } from "@components/ALComponents";

function PackagingCard({ gift, productData, selectedPackaging, setSelectedPackaging, isLoading }) {
  const isDataAvailable = !isLoading && Boolean(productData);

  return (
    <button
      type="button"
      className={cn(
        "mt-[15px] desktop:mt-[20px] border border-light-grey rounded-[4px] p-[15px] w-full desktop:w-[375px]",
        isDataAvailable && selectedPackaging?.handle === productData.handle && "border-black"
      )}
      onClick={() => isDataAvailable && setSelectedPackaging(productData)}
      disabled={!isDataAvailable}
    >
      {!isDataAvailable ? (
        <div>
          <ALSkeleton height={185} className="desktop:h-[203px]" />
          <div className="flex justify-between py-[10px]">
            <ALSkeleton height={20} />
          </div>
          <ALSkeleton height={40} />
        </div>
      ) : (
        <>
          <div className="h-[185px] desktop:h-[203px]">
            <ALShopifyImage
              width="100%"
              height="100%"
              url={productData?.shopify.images?.[0]?.url}
              alt={productData?.shopify.images?.[0]?.altText}
              imageClassName="w-full h-full object-[center_65%]"
            />
          </div>
          <div className="flex justify-between py-[10px]">
            <h3 className="typo-h3-bold desktop:typo-body-bold">{gift.title}</h3>
            <p className="typo-body-bold desktop:typo-micro">{productData.formattedFullPrice}</p>
          </div>

          <p className="typo-body desktop:typo-micro text-left">{gift.line1}</p>
          <p className="typo-body desktop:typo-micro text-left">{gift.line2}</p>
        </>
      )}
    </button>
  );
}

PackagingCard.propTypes = {
  gift: PropTypes.shape({
    title: PropTypes.string.isRequired,
    line1: PropTypes.string.isRequired,
    line2: PropTypes.string.isRequired,
  }).isRequired,
  productData: PropTypes.shape({
    handle: PropTypes.string.isRequired,
    formattedFullPrice: PropTypes.string.isRequired,
    shopify: PropTypes.shape({
      images: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string.isRequired,
          altText: PropTypes.string,
        })
      ).isRequired,
    }).isRequired,
  }).isRequired,
  selectedPackaging: PropTypes.objectOf(
    PropTypes.shape({
      handle: PropTypes.string.isRequired,
    })
  ).isRequired,
  setSelectedPackaging: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default PackagingCard;
